/**
 * Resolves a module's NetSuite product display name against the full NetSuite item list.
 * @param {Array<{id, displayname}>} netsuiteList Full NetSuite item list.
 * @param {string | number} netsuiteProductId Module row's `netsuite_product` id.
 * @returns {string} The product's display name, or "-" when not found.
 */
export function resolveNetsuiteProductName(netsuiteList, netsuiteProductId) {
    const product = netsuiteList.find((item) => String(item.id) === String(netsuiteProductId));
    return product?.displayname || "-";
}

/**
 * Parses a module row's `pre_requisites` (a JSON array of module ids).
 * @param {object} row Module row.
 * @returns {Array<number|string>} Prerequisite module ids, or [] when absent/invalid.
 */
export function parsePrerequisiteIds(row) {
    try {
        const prerequisiteIds = row.pre_requisites ? JSON.parse(row.pre_requisites) : [];
        return Array.isArray(prerequisiteIds) ? prerequisiteIds : [];
    } catch (error) {
        console.error("VersionModulesUtils.js->parsePrerequisiteIds->Error", error);
        return [];
    }
}
